

export const AppMarketingFooter = (props) => {

    return (
        <div className="footer footer-07">
            <div className="container">
                <div className="grid is-mobile">
                    <div className="grid_item">
                        <div>
                            <a href="/"  className="footer-link-white">Home</a>
                        </div>
                        <div>
                            <a href="/app"  className="footer-link-white">App</a>
                        </div>
                        <div>
                            <a href="/doc" target="_blank" rel="noreferrer"   className="footer-link-white">Developer API</a>
                        </div>
                    </div>
                    <div className="grid_item">
                        <div>
                            <a href="/terms" target="_blank" rel="noreferrer"  className="footer-link-white">Terms</a>
                        </div>
                        <div>
                            <a href="/privacy" target="_blank" rel="noreferrer"  className="footer-link-white">Privacy</a>
                        </div>

                    </div>
                    <div className="grid_item">
                        <div className="footer-wrapper">
                            <a href="https://twitter.com/tachikuai" target="_blank" rel="noreferrer"  className="social-link w-inline-block">
                                <i className="fa-brands fa-twitter"></i>
                            </a>
                        </div>
                        <div className="footer-wrapper">
                            <a href="https://discord.gg/KMRHjkwV" target="_blank" rel="noreferrer"  className="social-link w-inline-block">
                                <i className="fa-brands fa-discord"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );


}

